import {
  advProfile,
  deleteNotifications,
  forgotPassword,
  getMyData,
  login,
  newPassword,
  notifications,
  notificationsSchedule,
  profile,
  reset,
  updateProfile,
  updateShared,
} from "@/services/user.service";

export default {
  namespaced: true,
  state: {
    // STATUS
    userStatus: "init",
    profile: {},
    userData: null,
    userAdv: [],
    userNotification: null,
    userToasts: null,
  },
  getters: {
    // STATUS
    getProfile() {
      try {
        return JSON.parse(localStorage.getItem("profile"));
      } catch (error) {
        console.log("erro");
      }
    },
    getStateAdvices(state) {
      return state.userAdv;
    },
    // getAdvices STORAGE
    getAdvices() {
      return JSON.parse(localStorage.getItem("advices"));
    },
    // STATUS
    getUser() {
      return JSON.parse(localStorage.getItem("user"));
    },
    // STATUS
    getUserStatus(state) {
      return state.userStatus;
    },
    // STATUS
    getUserData(state) {
      return state.userData;
    },
    // get Notifications
    getNotifications(state) {
      return state.userNotification;
    },
    // get Toasts
    getToasts(state) {
      return state.userToasts;
    },
  },
  mutations: {
    // STATUS
    USER_STATUS(state, value) {
      state.userStatus = value;
    },
    USER_DATA(state, value) {
      state.userData = value;
    },
    USER_NOTIFICATION(state, value) {
      state.userNotification = value;
    },
    USER_TOAST(state, value) {
      state.userToasts = value;
    },
    USER_ADV_PROFILE(state, value) {
      state.userAdv = value;
    },
    CLEAR_LOGGED_USER(state, value) {
      localStorage.removeItem("profile");
      localStorage.removeItem("advices");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      state.userData = null;
      state.userAdv = null;
    },
  },
  actions: {
    async doLogout({ commit }) {
      commit("CLEAR_LOGGED_USER", "pending");
      commit("CLEAR_LOGGED_USER", "init");
    },
    async doLogin({ commit }, params) {
      commit("CLEAR_LOGGED_USER", "pending");
      commit("CLEAR_LOGGED_USER", "init");
      commit("USER_STATUS", "pending");
      try {
        const { data } = await login(params);
        commit("USER_STATUS", "init");
        localStorage.setItem("user", JSON.stringify(data.user));
        localStorage.setItem("token", data.idToken);
        return data;
      } catch (error) {
        commit("USER_STATUS", "init");
        throw error;
      }
    },
    async resetPassword({ commit }, params) {
      commit("USER_STATUS", "pending");
      try {
        const { data } = await reset(params);
        commit("USER_STATUS", "init");
        return data;
      } catch (error) {
        commit("USER_STATUS", "init");
        throw error;
      }
    },
    async requestNewPassword({ commit }, params) {
      commit("USER_STATUS", "pending");
      try {
        const { data } = await newPassword(params);
        commit("USER_STATUS", "init");
        return data;
      } catch (error) {
        commit("USER_STATUS", "init");
        throw error;
      }
    },
    async forgotPassword({ commit }, params) {
      commit("USER_STATUS", "pending");
      try {
        const { data } = await forgotPassword(params);
        commit("USER_STATUS", "init");
        return data;
      } catch (error) {
        commit("USER_STATUS", "init");
        throw error;
      }
    },
    async fetchProfile({ commit }, params) {
      commit("USER_STATUS", "pending");
      try {
        const { data } = await profile(params);
        localStorage.setItem("profile", JSON.stringify(data.profile));
        localStorage.setItem("advices", JSON.stringify(data.advices));
        console.log(data.advices);
        commit("USER_ADV_PROFILE", data.advices);
        commit("USER_STATUS", "init");
        commit("USER_DATA", data.profile);
        return data;
      } catch (error) {
        commit("USER_STATUS", "init");
        //commit('USER_DATA', error.response.data);
        throw error;
      }
    },
    async updateProfile({ commit }, params) {
      commit("USER_STATUS", "pending");
      try {
        const { data } = await updateProfile(params);
        const user = await getMyData(params);
        localStorage.setItem("user", JSON.stringify(user.data.items[0]));
        commit("USER_STATUS", "init");
        return data;
      } catch (error) {
        commit("USER_STATUS", "init");
        throw error;
      }
    },
    async updateShared({ commit }, params) {
      commit("USER_STATUS", "pending");
      try {
        const { data } = await updateShared(params);
        commit("USER_STATUS", "init");
        return data;
      } catch (error) {
        commit("USER_STATUS", "init");
        throw error;
      }
    },
    async adviceAndProfile({ commit }, params) {
      commit("USER_STATUS", "pending");
      try {
        const { data } = await advProfile(params);
        commit("USER_STATUS", "init");
        //commit('USER_DATA', data);
        console.log(data);
        return data;
      } catch (error) {
        commit("USER_STATUS", "init");
        throw error;
      }
    },
    async userNotifications({ commit }, params) {
      commit("USER_STATUS", "pending");
      try {
        const { data } = await notifications(params);
        commit("USER_STATUS", "init");
        commit("USER_TOAST", data);
        console.log(data);
        return data;
      } catch (error) {
        commit("USER_STATUS", "init");
        throw error;
      }
    },
    async myNotifications({ commit }, params) {
      commit("USER_STATUS", "pending");
      try {
        const { data } = await notificationsSchedule(params);
        commit("USER_STATUS", "init");
        commit("USER_NOTIFICATION", data);
        console.log(data);
        return data;
      } catch (error) {
        commit("USER_STATUS", "init");
        throw error;
      }
    },
    async deleteMyNotifications({ commit }) {
      commit("USER_STATUS", "pending");
      try {
        const { data } = await deleteNotifications();
        commit("USER_STATUS", "init");
        console.log(data, "data good");
        return data;
      } catch (error) {
        commit("USER_STATUS", "init");
        throw error;
      }
    },
  },
};
